import { HttpContextToken } from '@angular/common/http';

/** When true, auth interceptor does not attach Authorization (e.g. SMS API expects `accessToken` header). */
export const SKIP_AUTH_INTERCEPTOR = new HttpContextToken<boolean>(() => false);

/**
 * When true, the Livepass decrypt interceptor skips its normal decryption.
 * Create order + verify payment use PaymentDecryptService in PaymentService instead.
 */
export const SKIP_LIVEPASS_DECRYPT = new HttpContextToken<boolean>(() => false);
